export enum UInspectSectionTypeEnum {
  Page,
  Media,
  Question,
  Splat
}
